<template>
	<section class="small-12 large-6 columns animated fadeIn flex vertical-align siteNav" v-if="user">
        <ul class="small-12 columns float-left flex justify-right vertical-align">
            <li class="auto">
                <a class="quickAdd flex round justify-center vertical-align">
                    <i class="material-icons">add_task</i>
                </a>
            </li>
            <li class="auto">
                <a class="help flex border medium round justify-center vertical-align">
                    ?
                </a>
            </li>
            <li class="auto" v-if="future_item">
                <a class="primaryButton borderRadius4 upgrade">
					<i class="material-icons">upgrade</i>
                    Upgrade
                </a>
            </li>
            <li class="auto">
                <a class="avatar round">
                    <picture class="round" :style="avatarStyle" v-if="user.links.avatar"></picture>
                    <picture class="round noAvatar flex vertical-align justify-center" v-else>
                        <span>{{ user.attributes.profile.first_name | abbreviateName }}{{ user.attributes.profile.last_name | abbreviateName }}</span>
                    </picture>
                </a>
            </li>
        </ul>
    </section>
</template>

<script>

    // Import the filters
    import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SiteNav',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			avatarStyle: function() {

                try {

                    /*
                    **  Set the avatar
                    **  @prop: @here
                    */

                    if (this.user.links.avatar) return 'background: url(' + this.user.links.avatar + ') no-repeat center/cover;';

                    return;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to set avatar style.',
                        errorType: 'Application',
                        section: 'SiteNav',
						uid: 'oIhMoS6nQc70CeqLCmRf',
                        error: e
                    });

                }

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>